<template>
  <div>
    <!-- Top Navbar -->
    <div class="container-fluid navbar-expand-sm custom-navbar navbar">
      
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarContent">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse d-flex align-items-center justify-content-between" id="navbarContent">

        <!-- Left: ASTech Logo -->
        <a href="#">
          <img src="../../assets/ASTechLogo.png" alt="Logo" width="120" height="50">
        </a>

        <!-- Center: Sync / Offline Status -->
        <!-- <div class="flex-grow-1 d-flex justify-content-center">
          <div v-if="!isOnline" class="offline-box">
            You are offline. Changes will sync when connection is restored.
          </div>

          <div
            v-else-if="syncBannerVisible && syncBannerType === 'progress'"
            class="sync-progress-box"
          >
            <div>{{ syncStatus }}</div>

            <div v-if="isSyncing" class="small-sync-text">
              Processed: {{ syncProcessed }}/{{ syncTotal }}
              &nbsp;|&nbsp;
              Successful: {{ syncSucceeded }}
              &nbsp;|&nbsp;
              Failed: {{ syncFailed }}
            </div>

            <div v-if="isSyncing && syncTotal > 0" class="sync-progress-bar">
              <div
                class="sync-progress-fill"
                :style="{ width: `${(syncProcessed / syncTotal) * 100}%` }"
              ></div>
            </div>
          </div>

          <div
            v-else-if="syncBannerVisible && syncBannerType === 'success'"
            class="sync-complete-box"
          >
            {{ syncStatus }}
          </div>

          <div
            v-else-if="syncBannerVisible && syncBannerType === 'error'"
            class="offline-box"
          >
            {{ syncStatus }}
          </div>

          <div
            v-else-if="offlineQueueCount > 0"
            class="sync-progress-box"
          >
            {{ offlineQueueCount }} pending change{{ offlineQueueCount === 1 ? '' : 's' }} waiting to sync.
          </div>
        </div> -->

        <!-- Right: User Info + Client Logo -->
        <div class="d-flex align-items-center">
          <div class="user-info mr-3">
            <div>Logged in as: {{ username }}</div>
            <div>Role: {{ formatRole(role) }}</div>
          </div>

          <a href="#">
            <img class="client_logo" src="../../assets/client_logo.png" width="160" height="45">
          </a>
        </div>

      </div>
    </div>

    <!-- Navigation Links -->
    <ul class="navbar-nav">

      <!-- <li class="nav-item">
        <router-link
          to="/dashboard"
          class="nav-link-examiner"
          :class="{ active: activeLink === 'dashboard' }"
          @click="setActiveLink('dashboard')"
        >
          Dashboard
        </router-link>
      </li> -->

      <li class="nav-item" v-if="role === 'admin'">
        <router-link to="/view-users"
          class="nav-link-examiner" 
          v-bind:class="{ active: activeLink === 'view-users' }"
          @click="setActiveLink('view-users')">View Staff
        </router-link>
      </li>

      <li class="nav-item" v-if="role === 'admin'">
        <router-link to="/view-users-trainees"
        class="nav-link-examiner" 
        v-bind:class="{ active: activeLink === 'view-users' }"
        @click="setActiveLink('view-users-trainees')">View Trainees
        </router-link>
      </li>

      <li class="nav-item" v-if="role === 'instructor'">
        <router-link to="/instructor-home"
          class="nav-link-examiner" 
          v-bind:class="{ active: activeLink === 'inst-home' }"
          @click="setActiveLink('inst-home')">Home
        </router-link>
      </li>

      <li class="nav-item" v-if="role === 'trainee'">
        <router-link to="/trainee-home"
          class="nav-link-examiner" 
          v-bind:class="{ active: activeLink === 'trainee-home' }"
          @click="setActiveLink('trainee-home')">Home
        </router-link>
      </li>

      <li class="nav-item" v-if="role === 'practical_manager' || role === 'project_manager' || role === 'examiner'">
        <router-link
          to="/dashboard"
          class="nav-link-examiner"
          :class="{ active: activeLink === 'dashboard' }"
          @click="setActiveLink('dashboard')"
        >
          Dashboard
        </router-link>
      </li>

      <li class="nav-item" v-if="role === 'practical_manager' || role === 'examiner'">
        <router-link
          to="/products"
          class="nav-link-examiner"
          :class="{ active: activeLink === 'products' }"
          @click="setActiveLink('products')"
        >
          {{ $labels.product }}s
        </router-link>
      </li>

      <li class="nav-item" v-if="role === 'project_manager' || role === 'examiner'">
        <router-link
          to="/projects"
          class="nav-link-examiner"
          :class="{ active: activeLink === 'projects' }"
          @click="setActiveLink('projects')"
        >
          {{ $labels.project }}s
        </router-link>
      </li>

      <li class="nav-item" v-if="role === 'project_manager' || role === 'examiner'">
        <router-link
          to="/trainees"
          class="nav-link-examiner"
          :class="{ active: activeLink === 'trainees' }"
          @click="setActiveLink('trainees')"
        >
          Trainees
        </router-link>
      </li>

      <li class="nav-item" v-if="role === 'project_manager' || role === 'examiner'">
        <router-link
          to="/logbooks"
          class="nav-link-examiner"
          :class="{ active: activeLink === 'logbooks' }"
          @click="setActiveLink('logbooks')"
        >
          Logbooks
        </router-link>
      </li>

      <li class="nav-item" v-if="role === 'project_manager' || role === 'practical_manager' || role === 'examiner'">
        <router-link
          to="/help"
          class="nav-link-examiner"
          :class="{ active: activeLink === 'help' }"
          @click="setActiveLink('help')"
        >
          Help
        </router-link>
      </li>

      <li class="nav-item">
        <a class="nav-link-examiner" style="color: red;" @click="logout">
          Logout
        </a>
      </li>

    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PageHeader',

  data() {
    return {
      username: '',
      role: '',
      activeLink: '',
    };
  },
  computed: {
    ...mapState([
      'isOnline',
      'isSyncing',
      'syncStatus',
      'syncBannerVisible',
      'syncBannerType',
      'offlineQueueCount',
      'syncTotal',
      'syncProcessed',
      'syncSucceeded',
      'syncFailed',
    ]),
  },
  methods: {
    logout() {
      localStorage.clear();
      this.$router.push({ name: 'LoginPage' });
    },

    setActiveLink(link) {
      this.activeLink = this.activeLink === link ? '' : link;
    },

    formatRole(role) {
      if (!role) return '';
      return role
        .replace(/_/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase());
    },
  },

  mounted() {
    this.username = localStorage.getItem('username') || '';
    this.role = localStorage.getItem('role') || '';
  },
};
</script>

<style scoped>
.navbar-collapse {
    display: flex;
    align-items: center;
    height: 100%;
}

.navbar-nav {
    position: sticky;
    top: -1px;
    display: flex;
    width: 100%;
    flex-direction: row; 
    border-bottom: 1px solid #acacac;
    background: linear-gradient(to top, rgb(226, 226, 226), #FFFFFF);
    z-index: 1;
}

.navbar-nav .nav-item {
    align-items: center;
    height: 100%; 

}

.navbar {
    align-items: center;

    justify-content: space-between;
    padding: 0.5rem 1rem;
}

.container-fluid {
    background: linear-gradient(to right, #87B4FA, #FFFFFF);
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    width: 100%;
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-bottom: 1px;
    padding-top: 1px;
    margin-top: 0 !important;
    box-shadow: 0 4px 10px rgba(70, 52, 52, 0.2);
    border-bottom: 1px solid #acacac;
}

span {
    margin-top: 0px !important;
    border: none !important;
}



.user-info {
    color: #000000;
    margin-right: 10px;
    font-size: 13px;
    min-width: 150px;
}

.btn {
    margin-right: 10px;
}

.nav-link-examiner {
    color: black;
    /* Remove text decoration (underline) and add button-like styles */
    text-decoration: none;
    padding: 0px 10px;
    font-size: 14px;
    border-right: 1px solid #bdbdbd;
    display: inline-block;
    cursor: pointer;
    font-weight: bold;
}

.nav-link-examiner:hover {
    background-color: #ffffff;
    color: black
    /* moves the link a bit down when hovered */
}

.btn-primary {
    margin-bottom: 0px;
}

.client_logo{
    margin-right: 10px;
    margin-left: 10px;
}
</style>